import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductDocument.Save.IRequest;
type Response = Api.Core.ProductDocument.Save.IResponse;
type Headers = Api.Core.ProductDocument.Save.IHeaders;
const url = '/api/ProductManagement/ProductDocument/:productId';
export default async function productDocumentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { productId: body?.productId, documentId: body.id }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
